import {Tracking, TrackingEvent} from '@common/tracking'
import {Page} from '@extensions/page'

export const trackPageClick = (page: Page): void => {
  page === 'my-tasks' && void Tracking.send(TrackingEvent.leftPanelMyTasksClick)
  page === 'others-tasks' &&
    void Tracking.send(TrackingEvent.leftPanelOtherTasksClick)
  page === 'projects' &&
    void Tracking.send(TrackingEvent.leftPanelMyCompanyClick)
  page === 'event-feed' &&
    void Tracking.send(TrackingEvent.leftPanelEventListClick)
  page === 'statistics' &&
    void Tracking.send(TrackingEvent.leftPanelReportsClick)
  page === 'billing' && void Tracking.send(TrackingEvent.leftPanelBilling)
  page === 'feedback' && void Tracking.send(TrackingEvent.leftPanelSupportClick)
}
